import { Chip, ChipProps } from "@heroui/react";

interface FeedbackCategoryProps {
  children: React.ReactNode;
  color: ChipProps["color"];
  name: string;
  numberOfVotes: number;
}

export function FeedbackCategory({ children, color, name, numberOfVotes }: FeedbackCategoryProps) {
  return (
    <div className="rounded-lg border p-2 dark:border-none dark:bg-content1">
      <div className="flex items-center justify-between">
        <Chip color={color} radius="sm" variant="flat">
          {name}
        </Chip>
        <Chip radius="sm" size="sm" variant="flat">
          {numberOfVotes}
        </Chip>
      </div>
      {children}
    </div>
  );
}
